import {
	productRecs
} from '../productRecs/_productRecs';

		
var url = window.location.href.split('?')[0];
var topPersonalizationInfo = {};
var debug = false;

var recsArrayInit = [];
var recsArrayFinal = [];
var recInteractionData = {};
var maxRecSize =20;


var resetVars = () => {
	url = window.location.href.split('?')[0];
	topPersonalizationInfo = {};
	debug = false;

    recsArrayInit = [];
    recsArrayFinal = [];
    recInteractionData = {};
}


export var callRecs = (zone, details) => {
	try{
		resetVars();
		setTopPersonalizationInfo();
        setRecommendationData(zone, details);

	if('SCPZ1' == zone){
		let zoneTemp = zone;
		if ($("div.recently-removed-results").length > 0) {
			zoneTemp = "SCPZ2";
		}
		$(window).on('showRecs', function () { showRecs(zoneTemp); });
		if(window.location.host == 'localhost') showRecs(zoneTemp);
		}
	}catch(e){
		if(debug){ console.log(e);}
	}
};


var setRecommendationData = (zone, details) => {
	//setting all rec data into a window scoped variable for adobe sdk migration
	window.recCallData = window.recCallData ? window.recCallData : [];
	if('ACMZ1' == zone) window.recCallData = []; //SCPZ1 needs to be removed from object, else new recs will be returned and overlay current recs on cart.
	
	if(recCallData.length > 0){
		if(recCallData[0].url != url){
			window.recCallData = [];
			recCallData.push({"url" : url});
		}
	}else{
		recCallData.push({"url" : url});
	}
	
    const thisData = {zone, partNumber:[]};
    
    if(details?.promotedDetails){
    	for(var i = 0; i < details.promotedDetails.length; i++){
    		var thisDetail = details.promotedDetails[i];
    		if(thisData.partNumber.length < 11 && thisDetail && thisDetail.pid && thisData.partNumber.indexOf(thisDetail.pid) === -1){
    			thisData.partNumber.push(thisDetail.pid);
    		}else{
    			//only get PIDs for first 10 products
    			break;
    		}
    	}
    }
    thisData.favoriteBrand = (topPersonalizationInfo && topPersonalizationInfo.favoriteBrand) ? topPersonalizationInfo.favoriteBrand : '';
    thisData.favoriteCategoryId = (topPersonalizationInfo && topPersonalizationInfo.favoriteSuperCat) ? topPersonalizationInfo.favoriteSuperCat : '';
    recCallData.push({'ProductRecs' : thisData});
}

function setOptiRecs(){
	window.optiSmartRecs = [
		{
			"widget": "SCPZ1",
			"alias": "",
			"position": "basketWidget",
			"recs": [
				{
					"prices": {
						"USD": {
							"unitPrice": 39.99,
							"salePrice": 39.99
						}
					},
					"url": "https://www.dillards.com/p/levis-469-loose-fit-12-inseam-denim-shorts/517693260",
					"img": "https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/levis-469-loose-fit-12-inseam-denim-shorts/00000000_zi_d56a5eff-143b-4146-ad85-569b13c1da83.jpg",
					"attributes": {
						"review_number": "3.67000",
						"not_contains_girls": "true",
						"term": "short",
						"reviewrating": "3",
						"decade": "058x",
						"century": "05xx",
						"new_arrival": "false",
						"dept": "0581",
						"brand": "bad",
						"pricerange": "cheap",
						"primary_category": "men",
						"can_ship_international": "true",
						"discount": null,
						"product_class": "h5m",
						"on_sale": "false"
					},
					"id": 295816420352,
					"title": "Levis� 469 Loose Fit 12 Inseam Denim Shorts",
					"refCode": "20435490"
				},
				{
					"prices": {
						"USD": {
							"unitPrice": 75,
							"salePrice": 75
						}
					},
					"url": "https://www.dillards.com/p/daniel-cremieux-signature-label-stretch-flat-front-pants/518465783",
					"img": "https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/daniel-cremieux-signature-label-stretch-flat-front-pants/00000000_zi_316f92c1-106d-449c-8f63-d45f144da3d2.jpg",
					"attributes": {
						"review_number": "0.0",
						"not_contains_girls": "true",
						"term": "trouser",
						"reviewrating": "0",
						"decade": "054x",
						"century": "05xx",
						"new_arrival": "false",
						"dept": "0547",
						"brand": "cremieux",
						"pricerange": "average",
						"primary_category": "men",
						"can_ship_international": "true",
						"discount": null,
						"product_class": "345",
						"on_sale": "false"
					},
					"id": 295816420402,
					"title": "Daniel Cremieux Signature Label Stretch Flat Front Pants",
					"refCode": "20485307"
				},
				{
					"prices": {
						"USD": {
							"unitPrice": 228,
							"salePrice": 228
						}
					},
					"url": "https://www.dillards.com/p/chanel--bleu-de-chanel---parfum/508119520",
					"img": "https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/chanel--bleu-de-chanel---parfum/05420833_zi.jpg",
					"attributes": {
						"review_number": "4.83000",
						"not_contains_girls": "true",
						"reviewrating": "300",
						"decade": "003x",
						"century": "00xx",
						"new_arrival": "false",
						"dept": "0037",
						"brand": "chanel",
						"pricerange": "expensive",
						"primary_category": "beauty",
						"can_ship_international": "true",
						"discount": null,
						"product_class": "eev|eev",
						"on_sale": "false"
					},
					"id": 295816420452,
					"title": "CHANEL BLEU DE CHANEL PARFUM",
					"refCode": "05420833"
				},
				{
					"prices": {
						"USD": {
							"unitPrice": 160,
							"salePrice": 160
						}
					},
					"url": "https://www.dillards.com/p/birkenstock-soft-footbed-boston-clogs/504545835",
					"img": "https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/birkenstock-soft-footbed-boston-clogs/00000000_zi_77fd8ceb-9699-46b8-929e-e1545bf19efa.jpg",
					"attributes": {
						"review_number": "4.79000",
						"not_contains_girls": "true",
						"reviewrating": "53",
						"decade": "061x",
						"century": "06xx",
						"new_arrival": "false",
						"dept": "0619",
						"brand": "birkenstock",
						"pricerange": "expensive",
						"primary_category": "shoes",
						"can_ship_international": "true",
						"discount": null,
						"product_class": "ynh",
						"on_sale": "false"
					},
					"id": 295816420502,
					"title": "Birkenstock Mens Boston Oiled Leather Soft Footbed Slip-On Clogs",
					"refCode": "04278203"
				},
				{
					"prices": {
						"USD": {
							"unitPrice": 168,
							"salePrice": 168
						}
					},
					"url": "https://www.dillards.com/p/polo-ralph-lauren-classic-fit-graphic-mesh-short-sleeve-polo-shirt/518223767",
					"img": "https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/polo-ralph-lauren-classic-fit-graphic-mesh-short-sleeve-polo-shirt/00000001_zi_cffc410e-7df5-409d-8209-edf0849e6cbb.jpg",
					"attributes": {
						"review_number": "5.00000",
						"not_contains_girls": "true",
						"term": "polo shirt",
						"reviewrating": "4",
						"decade": "054x",
						"century": "05xx",
						"new_arrival": "false",
						"dept": "0545",
						"brand": "polo ralph lauren",
						"pricerange": "expensive",
						"primary_category": "men",
						"can_ship_international": "true",
						"discount": null,
						"product_class": "620",
						"on_sale": "false"
					},
					"id": 295816420552,
					"title": "Polo Ralph Lauren Classic Fit Graphic Mesh Short Sleeve Polo Shirt",
					"refCode": "20470491"
				},
				{
					"prices": {
						"USD": {
							"unitPrice": 115,
							"salePrice": 115
						}
					},
					"url": "https://www.dillards.com/p/polo-ralph-lauren-straight-fit-flat-front-stretch-twill-chino-pants/507303505",
					"img": "https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/polo-ralph-lauren-straight-fit-flat-front-stretch-twill-chino-pants/00000001_zi_2f71e973-80f9-492e-af9b-11a59b63eda7.jpg",
					"attributes": {
						"review_number": "4.57000",
						"not_contains_girls": "true",
						"term": "polo shirt",
						"reviewrating": "355",
						"decade": "054x",
						"century": "05xx",
						"new_arrival": "false",
						"dept": "0545",
						"brand": "polo ralph lauren",
						"pricerange": "expensive",
						"primary_category": "men",
						"can_ship_international": "true",
						"discount": null,
						"product_class": "340|340",
						"on_sale": "false"
					},
					"id": 295816420602,
					"title": "Polo Ralph Lauren Straight Fit Flat Front Stretch Twill Chino Pants",
					"refCode": "05099682"
				},
				{
					"prices": {
						"USD": {
							"unitPrice": 45,
							"salePrice": 45
						}
					},
					"url": "https://www.dillards.com/p/roundtree--yorke-travelsmart-corecomfort-flat-front-classic-relaxed-fit-chino-pants/509640715",
					"img": "https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/roundtree--yorke-travelsmart-corecomfort-flat-front-classic-relaxed-fit-chino-pants/00000003_zi_dark_navy05814782.jpg",
					"attributes": {
						"review_number": "4.74000",
						"not_contains_girls": "true",
						"term": "trouser",
						"reviewrating": "479",
						"decade": "056x",
						"century": "05xx",
						"new_arrival": "false",
						"dept": "0562",
						"brand": "roundtree & yorke",
						"pricerange": "cheap",
						"primary_category": "men",
						"can_ship_international": "true",
						"discount": null,
						"product_class": "4ca",
						"on_sale": "false"
					},
					"id": 295816420652,
					"title": "Roundtree  Yorke TravelSmart Ultimate Performance Classic Fit Flat Front Non-Iron Chino Pants",
					"refCode": "05814782"
				},
				{
					"prices": {
						"USD": {
							"unitPrice": 89.5,
							"salePrice": 89.5
						}
					},
					"url": "https://www.dillards.com/p/polo-ralph-lauren-classic-fit-stretch-twill-shorts/507490463",
					"img": "https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/polo-ralph-lauren-classic-fit-stretch-twill-shorts/00000000_zi_a36593d1-4972-4b92-9a41-cd46997f36fd.jpg",
					"attributes": {
						"review_number": "4.70000",
						"not_contains_girls": "true",
						"term": "polo shirt",
						"reviewrating": "241",
						"decade": "054x",
						"century": "05xx",
						"new_arrival": "false",
						"dept": "0545",
						"brand": "polo ralph lauren",
						"pricerange": "average",
						"primary_category": "men",
						"can_ship_international": "true",
						"discount": null,
						"product_class": "440|440|44a",
						"on_sale": "false"
					},
					"id": 295816420702,
					"title": "Polo Ralph Lauren Classic Fit Stretch 9 Inseam Twill Shorts",
					"refCode": "05179157"
				},
				{
					"prices": {
						"USD": {
							"unitPrice": 110,
							"salePrice": 110
						}
					},
					"url": "https://www.dillards.com/p/polo-ralph-lauren-custom-fit-solid-mesh-polo-shirt/501116181",
					"img": "https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/polo-ralph-lauren-custom-fit-solid-mesh-polo-shirt/00000000_zi_05b0b2a5-3ef9-4ee8-962d-a7569c155629.jpg",
					"attributes": {
						"review_number": "4.57000",
						"not_contains_girls": "true",
						"term": "polo shirt",
						"reviewrating": "987",
						"decade": "054x",
						"century": "05xx",
						"new_arrival": "true",
						"dept": "0545",
						"brand": "polo ralph lauren",
						"pricerange": "expensive",
						"primary_category": "men",
						"can_ship_international": "true",
						"discount": null,
						"product_class": "622|622",
						"on_sale": "false"
					},
					"id": 295816420752,
					"title": "Polo Ralph Lauren Custom Slim Fit Solid Mesh Polo Shirt",
					"refCode": "02744020"
				},
				{
					"prices": {
						"USD": {
							"unitPrice": 98.5,
							"salePrice": 98.5
						}
					},
					"url": "https://www.dillards.com/p/polo-ralph-lauren-gellar-cargo-shorts/501135649",
					"img": "https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/polo-ralph-lauren-gellar-cargo-shorts/00000000_zi_75b686a5-f140-4a43-bf97-353ed87304cd.jpg",
					"attributes": {
						"review_number": "4.44000",
						"not_contains_girls": "true",
						"term": "polo shirt",
						"reviewrating": "225",
						"decade": "054x",
						"century": "05xx",
						"new_arrival": "false",
						"dept": "0545",
						"brand": "polo ralph lauren",
						"pricerange": "average",
						"primary_category": "men",
						"can_ship_international": "true",
						"discount": null,
						"product_class": "440|440",
						"on_sale": "false"
					},
					"id": 295816420802,
					"title": "Polo Ralph Lauren Gellar 10.25 Inseam Cargo Shorts",
					"refCode": "02744559"
				},
				{
					"prices": {
						"USD": {
							"unitPrice": 59.5,
							"salePrice": 59.5
						}
					},
					"url": "https://www.dillards.com/p/roundtree--yorke-travel-smart-ultimate-comfort-classic-fit-pleat-front-non-iron-twill-dress-pants/506569116",
					"img": "https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/roundtree--yorke-travel-smart-ultimate-comfort-classic-fit-pleat-front-non-iron-twill-dress-pants/00000001_zi_charcoal04806965.jpg",
					"attributes": {
						"review_number": "4.42000",
						"not_contains_girls": "true",
						"term": "dress",
						"reviewrating": "253",
						"decade": "056x",
						"century": "05xx",
						"new_arrival": "false",
						"dept": "0563",
						"brand": "roundtree & yorke",
						"contains_dress": "true",
						"pricerange": "average",
						"primary_category": "men",
						"can_ship_international": "true",
						"discount": null,
						"product_class": "111",
						"on_sale": "false"
					},
					"id": 295816420852,
					"title": "Roundtree  Yorke TravelSmart Luxury Gabardine Ultimate Comfort Classic Fit Non-Iron Pleated-Front Dress Pants",
					"refCode": "04806965"
				},
				{
					"prices": {
						"USD": {
							"unitPrice": 49.5,
							"salePrice": 49.5
						}
					},
					"url": "https://www.dillards.com/p/roundtree--yorke-travel-smart-non-iron-pleated-ultimate-comfort-microfiber-stretch-dress-pants/508119670",
					"img": "https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/roundtree--yorke-travel-smart-non-iron-pleated-ultimate-comfort-microfiber-stretch-dress-pants/00000001_zi_light_khaki05421659.jpg",
					"attributes": {
						"review_number": "4.60000",
						"not_contains_girls": "true",
						"term": "dress",
						"reviewrating": "270",
						"decade": "056x",
						"century": "05xx",
						"new_arrival": "false",
						"dept": "0563",
						"brand": "roundtree & yorke",
						"contains_dress": "true",
						"pricerange": "average",
						"primary_category": "men",
						"can_ship_international": "true",
						"discount": null,
						"product_class": "117",
						"on_sale": "false"
					},
					"id": 295816420902,
					"title": "Roundtree  Yorke TravelSmart Classic Fit Non-Iron Ultimate Comfort Microfiber Pleated-Front Dress Pants",
					"refCode": "05421659"
				},
				{
					"prices": {
						"USD": {
							"unitPrice": 70,
							"salePrice": 70
						}
					},
					"url": "https://www.dillards.com/p/callaway-chevron-foulard-print-short-sleeve-golf-polo-shirt/518362404",
					"img": "https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/callaway-chevron-foulard-print-short-sleeve-golf-polo-shirt/00000000_zi_08264ad9-21f7-4bd7-830f-a9406be63be6.jpg",
					"attributes": {
						"review_number": "0.0",
						"not_contains_girls": "true",
						"term": "polo shirt",
						"reviewrating": "0",
						"decade": "057x",
						"century": "05xx",
						"new_arrival": "false",
						"dept": "0576",
						"brand": "callaway",
						"pricerange": "average",
						"primary_category": "men",
						"can_ship_international": "true",
						"discount": null,
						"product_class": "625",
						"on_sale": "false"
					},
					"id": 295816420952,
					"title": "Callaway Chevron Foulard Print Short Sleeve Golf Polo Shirt",
					"refCode": "20478385"
				},
				{
					"prices": {
						"USD": {
							"unitPrice": 89.5,
							"salePrice": 89.5
						}
					},
					"url": "https://www.dillards.com/p/cremieux-blue-label-soho-tailored-fit-5-pocket-sateen-stretch-pants/516597729",
					"img": "https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/cremieux-blue-label-soho-tailored-fit-5-pocket-sateen-stretch-pants/00000000_zi_d19029ee-d276-4ee0-9161-37cbaf44a666.jpg",
					"attributes": {
						"review_number": "4.77000",
						"not_contains_girls": "true",
						"term": "trouser",
						"reviewrating": "35",
						"decade": "054x",
						"century": "05xx",
						"new_arrival": "false",
						"dept": "0547",
						"brand": "cremieux",
						"pricerange": "average",
						"primary_category": "men",
						"can_ship_international": "true",
						"discount": null,
						"product_class": "343",
						"on_sale": "false"
					},
					"id": 295816421002,
					"title": "Cremieux Blue Label CMX 5-Pocket Tailored-Fit Sateen Stretch Pants",
					"refCode": "20375397"
				},
				{
					"prices": {
						"USD": {
							"unitPrice": 69.5,
							"salePrice": 69.5
						}
					},
					"url": "https://www.dillards.com/p/cremieux-madison-flat-front-twill-chino-pants/508522676",
					"img": "https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/cremieux-madison-flat-front-twill-chino-pants/00000000_zi_782fbf59-df51-42b4-9574-4f61ae9534d7.jpg",
					"attributes": {
						"review_number": "4.70000",
						"not_contains_girls": "true",
						"term": "trouser",
						"reviewrating": "90",
						"decade": "054x",
						"century": "05xx",
						"new_arrival": "false",
						"dept": "0547",
						"brand": "cremieux",
						"pricerange": "average",
						"primary_category": "men",
						"can_ship_international": "true",
						"discount": null,
						"product_class": "343|343",
						"on_sale": "false"
					},
					"id": 295816421052,
					"title": "Cremieux Blue Label Madison Classic Fit Comfort Stretch Flat-Front Twill Chino Pants",
					"refCode": "05585769"
				},
				{
					"prices": {
						"USD": {
							"unitPrice": 125,
							"salePrice": 125
						}
					},
					"url": "https://www.dillards.com/p/hart-schaffner-marx-tailored-single-pleat-chicago-dress-pants/505595789",
					"img": "https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/hart-schaffner-marx-tailored-single-pleat-chicago-dress-pants/04582746_zi_tan.jpg",
					"attributes": {
						"review_number": "4.39000",
						"not_contains_girls": "true",
						"term": "dress",
						"reviewrating": "28",
						"decade": "053x",
						"century": "05xx",
						"new_arrival": "false",
						"dept": "0535",
						"brand": "hart schaffner marx",
						"contains_dress": "true",
						"pricerange": "expensive",
						"primary_category": "men",
						"can_ship_international": "true",
						"discount": null,
						"product_class": "112|111",
						"on_sale": "false"
					},
					"id": 295816421102,
					"title": "Hart Schaffner Marx Tailored Regular Chicago Fit Single-Pleat Dress Pants",
					"refCode": "04582746"
				},
				{
					"prices": {
						"USD": {
							"unitPrice": 125,
							"salePrice": 125
						}
					},
					"url": "https://www.dillards.com/p/polo-ralph-lauren-classic-fit-stretch-mesh-zip-short-sleeve-polo-shirt/518205741",
					"img": "https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/polo-ralph-lauren-classic-fit-stretch-mesh-zip-short-sleeve-polo-shirt/00000001_zi_22d7cf3d-08a6-49f0-bb0a-a9876787055e.jpg",
					"attributes": {
						"review_number": "0.0",
						"not_contains_girls": "true",
						"term": "polo shirt",
						"reviewrating": "0",
						"decade": "054x",
						"century": "05xx",
						"new_arrival": "false",
						"dept": "0545",
						"brand": "polo ralph lauren",
						"pricerange": "expensive",
						"primary_category": "men",
						"can_ship_international": "true",
						"discount": null,
						"product_class": "620",
						"on_sale": "false"
					},
					"id": 295816421152,
					"title": "Polo Ralph Lauren Classic Fit Stretch Mesh Zip Short Sleeve Polo Shirt",
					"refCode": "20469132"
				},
				{
					"prices": {
						"USD": {
							"unitPrice": 125,
							"salePrice": 125
						}
					},
					"url": "https://www.dillards.com/p/hart-schaffner-marx-tailored-flat-front-chicago-dress-pants/505595908",
					"img": "https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/hart-schaffner-marx-tailored-flat-front-chicago-dress-pants/00000001_zi_grey04582755.jpg",
					"attributes": {
						"review_number": "4.58000",
						"not_contains_girls": "true",
						"term": "dress",
						"reviewrating": "26",
						"decade": "053x",
						"century": "05xx",
						"new_arrival": "false",
						"dept": "0535",
						"brand": "hart schaffner marx",
						"contains_dress": "true",
						"pricerange": "expensive",
						"primary_category": "men",
						"can_ship_international": "true",
						"discount": null,
						"product_class": "211",
						"on_sale": "false"
					},
					"id": 295816421202,
					"title": "Hart Schaffner Marx Classic Fit Flat-Front Dress Pants",
					"refCode": "04582755"
				}
			]
		},
		{
			"widget": "SCPZ2",
			"alias": "",
			"position": "emptyBasketWidget",
			"recs": [
				{
					"prices": {
						"USD": {
							"unitPrice": 39.99,
							"salePrice": 39.99
						}
					},
					"url": "https://www.dillards.com/p/levis-469-loose-fit-12-inseam-denim-shorts/517693260",
					"img": "https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/betsey-johnson-pearl-and-crystal-frog-stud-earrings/04585463_zi_gold.jpg",
					"attributes": {
						"review_number": "3.67000",
						"not_contains_girls": "true",
						"term": "short",
						"reviewrating": "3",
						"decade": "058x",
						"century": "05xx",
						"new_arrival": "false",
						"dept": "0581",
						"brand": "beep",
						"pricerange": "cheap",
						"primary_category": "men",
						"can_ship_international": "true",
						"discount": null,
						"product_class": "h5m",
						"on_sale": "false"
					},
					"id": 295816420352,
					"title": "Levis� 469 Loose Fit 12 Inseam Denim Shorts",
					"refCode": "20435490"
				},
				{
					"prices": {
						"USD": {
							"unitPrice": 75,
							"salePrice": 75
						}
					},
					"url": "https://www.dillards.com/p/daniel-cremieux-signature-label-stretch-flat-front-pants/518465783",
					"img": "https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/daniel-cremieux-signature-label-stretch-flat-front-pants/00000000_zi_316f92c1-106d-449c-8f63-d45f144da3d2.jpg",
					"attributes": {
						"review_number": "0.0",
						"not_contains_girls": "true",
						"term": "trouser",
						"reviewrating": "0",
						"decade": "054x",
						"century": "05xx",
						"new_arrival": "false",
						"dept": "0547",
						"brand": "cremieux",
						"pricerange": "average",
						"primary_category": "men",
						"can_ship_international": "true",
						"discount": null,
						"product_class": "345",
						"on_sale": "false"
					},
					"id": 295816420402,
					"title": "Daniel Cremieux Signature Label Stretch Flat Front Pants",
					"refCode": "20485307"
				},
				{
					"prices": {
						"USD": {
							"unitPrice": 228,
							"salePrice": 228
						}
					},
					"url": "https://www.dillards.com/p/chanel--bleu-de-chanel---parfum/508119520",
					"img": "https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/chanel--bleu-de-chanel---parfum/05420833_zi.jpg",
					"attributes": {
						"review_number": "4.83000",
						"not_contains_girls": "true",
						"reviewrating": "300",
						"decade": "003x",
						"century": "00xx",
						"new_arrival": "false",
						"dept": "0037",
						"brand": "chanel",
						"pricerange": "expensive",
						"primary_category": "beauty",
						"can_ship_international": "true",
						"discount": null,
						"product_class": "eev|eev",
						"on_sale": "false"
					},
					"id": 295816420452,
					"title": "CHANEL BLEU DE CHANEL PARFUM",
					"refCode": "05420833"
				},
				{
					"prices": {
						"USD": {
							"unitPrice": 160,
							"salePrice": 160
						}
					},
					"url": "https://www.dillards.com/p/birkenstock-soft-footbed-boston-clogs/504545835",
					"img": "https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/birkenstock-soft-footbed-boston-clogs/00000000_zi_77fd8ceb-9699-46b8-929e-e1545bf19efa.jpg",
					"attributes": {
						"review_number": "4.79000",
						"not_contains_girls": "true",
						"reviewrating": "53",
						"decade": "061x",
						"century": "06xx",
						"new_arrival": "false",
						"dept": "0619",
						"brand": "birkenstock",
						"pricerange": "expensive",
						"primary_category": "shoes",
						"can_ship_international": "true",
						"discount": null,
						"product_class": "ynh",
						"on_sale": "false"
					},
					"id": 295816420502,
					"title": "Birkenstock Mens Boston Oiled Leather Soft Footbed Slip-On Clogs",
					"refCode": "04278203"
				},
				{
					"prices": {
						"USD": {
							"unitPrice": 168,
							"salePrice": 168
						}
					},
					"url": "https://www.dillards.com/p/polo-ralph-lauren-classic-fit-graphic-mesh-short-sleeve-polo-shirt/518223767",
					"img": "https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/polo-ralph-lauren-classic-fit-graphic-mesh-short-sleeve-polo-shirt/00000001_zi_cffc410e-7df5-409d-8209-edf0849e6cbb.jpg",
					"attributes": {
						"review_number": "5.00000",
						"not_contains_girls": "true",
						"term": "polo shirt",
						"reviewrating": "4",
						"decade": "054x",
						"century": "05xx",
						"new_arrival": "false",
						"dept": "0545",
						"brand": "polo ralph lauren",
						"pricerange": "expensive",
						"primary_category": "men",
						"can_ship_international": "true",
						"discount": null,
						"product_class": "620",
						"on_sale": "false"
					},
					"id": 295816420552,
					"title": "Polo Ralph Lauren Classic Fit Graphic Mesh Short Sleeve Polo Shirt",
					"refCode": "20470491"
				},
				{
					"prices": {
						"USD": {
							"unitPrice": 115,
							"salePrice": 115
						}
					},
					"url": "https://www.dillards.com/p/polo-ralph-lauren-straight-fit-flat-front-stretch-twill-chino-pants/507303505",
					"img": "https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/polo-ralph-lauren-straight-fit-flat-front-stretch-twill-chino-pants/00000001_zi_2f71e973-80f9-492e-af9b-11a59b63eda7.jpg",
					"attributes": {
						"review_number": "4.57000",
						"not_contains_girls": "true",
						"term": "polo shirt",
						"reviewrating": "355",
						"decade": "054x",
						"century": "05xx",
						"new_arrival": "false",
						"dept": "0545",
						"brand": "polo ralph lauren",
						"pricerange": "expensive",
						"primary_category": "men",
						"can_ship_international": "true",
						"discount": null,
						"product_class": "340|340",
						"on_sale": "false"
					},
					"id": 295816420602,
					"title": "Polo Ralph Lauren Straight Fit Flat Front Stretch Twill Chino Pants",
					"refCode": "05099682"
				},
				{
					"prices": {
						"USD": {
							"unitPrice": 45,
							"salePrice": 45
						}
					},
					"url": "https://www.dillards.com/p/roundtree--yorke-travelsmart-corecomfort-flat-front-classic-relaxed-fit-chino-pants/509640715",
					"img": "https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/roundtree--yorke-travelsmart-corecomfort-flat-front-classic-relaxed-fit-chino-pants/00000003_zi_dark_navy05814782.jpg",
					"attributes": {
						"review_number": "4.74000",
						"not_contains_girls": "true",
						"term": "trouser",
						"reviewrating": "479",
						"decade": "056x",
						"century": "05xx",
						"new_arrival": "false",
						"dept": "0562",
						"brand": "roundtree & yorke",
						"pricerange": "cheap",
						"primary_category": "men",
						"can_ship_international": "true",
						"discount": null,
						"product_class": "4ca",
						"on_sale": "false"
					},
					"id": 295816420652,
					"title": "Roundtree  Yorke TravelSmart Ultimate Performance Classic Fit Flat Front Non-Iron Chino Pants",
					"refCode": "05814782"
				},
				{
					"prices": {
						"USD": {
							"unitPrice": 89.5,
							"salePrice": 89.5
						}
					},
					"url": "https://www.dillards.com/p/polo-ralph-lauren-classic-fit-stretch-twill-shorts/507490463",
					"img": "https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/polo-ralph-lauren-classic-fit-stretch-twill-shorts/00000000_zi_a36593d1-4972-4b92-9a41-cd46997f36fd.jpg",
					"attributes": {
						"review_number": "4.70000",
						"not_contains_girls": "true",
						"term": "polo shirt",
						"reviewrating": "241",
						"decade": "054x",
						"century": "05xx",
						"new_arrival": "false",
						"dept": "0545",
						"brand": "polo ralph lauren",
						"pricerange": "average",
						"primary_category": "men",
						"can_ship_international": "true",
						"discount": null,
						"product_class": "440|440|44a",
						"on_sale": "false"
					},
					"id": 295816420702,
					"title": "Polo Ralph Lauren Classic Fit Stretch 9 Inseam Twill Shorts",
					"refCode": "05179157"
				},
				{
					"prices": {
						"USD": {
							"unitPrice": 110,
							"salePrice": 110
						}
					},
					"url": "https://www.dillards.com/p/polo-ralph-lauren-custom-fit-solid-mesh-polo-shirt/501116181",
					"img": "https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/polo-ralph-lauren-custom-fit-solid-mesh-polo-shirt/00000000_zi_05b0b2a5-3ef9-4ee8-962d-a7569c155629.jpg",
					"attributes": {
						"review_number": "4.57000",
						"not_contains_girls": "true",
						"term": "polo shirt",
						"reviewrating": "987",
						"decade": "054x",
						"century": "05xx",
						"new_arrival": "true",
						"dept": "0545",
						"brand": "polo ralph lauren",
						"pricerange": "expensive",
						"primary_category": "men",
						"can_ship_international": "true",
						"discount": null,
						"product_class": "622|622",
						"on_sale": "false"
					},
					"id": 295816420752,
					"title": "Polo Ralph Lauren Custom Slim Fit Solid Mesh Polo Shirt",
					"refCode": "02744020"
				},
				{
					"prices": {
						"USD": {
							"unitPrice": 98.5,
							"salePrice": 98.5
						}
					},
					"url": "https://www.dillards.com/p/polo-ralph-lauren-gellar-cargo-shorts/501135649",
					"img": "https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/polo-ralph-lauren-gellar-cargo-shorts/00000000_zi_75b686a5-f140-4a43-bf97-353ed87304cd.jpg",
					"attributes": {
						"review_number": "4.44000",
						"not_contains_girls": "true",
						"term": "polo shirt",
						"reviewrating": "225",
						"decade": "054x",
						"century": "05xx",
						"new_arrival": "false",
						"dept": "0545",
						"brand": "polo ralph lauren",
						"pricerange": "average",
						"primary_category": "men",
						"can_ship_international": "true",
						"discount": null,
						"product_class": "440|440",
						"on_sale": "false"
					},
					"id": 295816420802,
					"title": "Polo Ralph Lauren Gellar 10.25 Inseam Cargo Shorts",
					"refCode": "02744559"
				},
				{
					"prices": {
						"USD": {
							"unitPrice": 59.5,
							"salePrice": 59.5
						}
					},
					"url": "https://www.dillards.com/p/roundtree--yorke-travel-smart-ultimate-comfort-classic-fit-pleat-front-non-iron-twill-dress-pants/506569116",
					"img": "https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/roundtree--yorke-travel-smart-ultimate-comfort-classic-fit-pleat-front-non-iron-twill-dress-pants/00000001_zi_charcoal04806965.jpg",
					"attributes": {
						"review_number": "4.42000",
						"not_contains_girls": "true",
						"term": "dress",
						"reviewrating": "253",
						"decade": "056x",
						"century": "05xx",
						"new_arrival": "false",
						"dept": "0563",
						"brand": "roundtree & yorke",
						"contains_dress": "true",
						"pricerange": "average",
						"primary_category": "men",
						"can_ship_international": "true",
						"discount": null,
						"product_class": "111",
						"on_sale": "false"
					},
					"id": 295816420852,
					"title": "Roundtree  Yorke TravelSmart Luxury Gabardine Ultimate Comfort Classic Fit Non-Iron Pleated-Front Dress Pants",
					"refCode": "04806965"
				},
				{
					"prices": {
						"USD": {
							"unitPrice": 49.5,
							"salePrice": 49.5
						}
					},
					"url": "https://www.dillards.com/p/roundtree--yorke-travel-smart-non-iron-pleated-ultimate-comfort-microfiber-stretch-dress-pants/508119670",
					"img": "https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/roundtree--yorke-travel-smart-non-iron-pleated-ultimate-comfort-microfiber-stretch-dress-pants/00000001_zi_light_khaki05421659.jpg",
					"attributes": {
						"review_number": "4.60000",
						"not_contains_girls": "true",
						"term": "dress",
						"reviewrating": "270",
						"decade": "056x",
						"century": "05xx",
						"new_arrival": "false",
						"dept": "0563",
						"brand": "roundtree & yorke",
						"contains_dress": "true",
						"pricerange": "average",
						"primary_category": "men",
						"can_ship_international": "true",
						"discount": null,
						"product_class": "117",
						"on_sale": "false"
					},
					"id": 295816420902,
					"title": "Roundtree  Yorke TravelSmart Classic Fit Non-Iron Ultimate Comfort Microfiber Pleated-Front Dress Pants",
					"refCode": "05421659"
				},
				{
					"prices": {
						"USD": {
							"unitPrice": 70,
							"salePrice": 70
						}
					},
					"url": "https://www.dillards.com/p/callaway-chevron-foulard-print-short-sleeve-golf-polo-shirt/518362404",
					"img": "https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/callaway-chevron-foulard-print-short-sleeve-golf-polo-shirt/00000000_zi_08264ad9-21f7-4bd7-830f-a9406be63be6.jpg",
					"attributes": {
						"review_number": "0.0",
						"not_contains_girls": "true",
						"term": "polo shirt",
						"reviewrating": "0",
						"decade": "057x",
						"century": "05xx",
						"new_arrival": "false",
						"dept": "0576",
						"brand": "callaway",
						"pricerange": "average",
						"primary_category": "men",
						"can_ship_international": "true",
						"discount": null,
						"product_class": "625",
						"on_sale": "false"
					},
					"id": 295816420952,
					"title": "Callaway Chevron Foulard Print Short Sleeve Golf Polo Shirt",
					"refCode": "20478385"
				},
				{
					"prices": {
						"USD": {
							"unitPrice": 89.5,
							"salePrice": 89.5
						}
					},
					"url": "https://www.dillards.com/p/cremieux-blue-label-soho-tailored-fit-5-pocket-sateen-stretch-pants/516597729",
					"img": "https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/cremieux-blue-label-soho-tailored-fit-5-pocket-sateen-stretch-pants/00000000_zi_d19029ee-d276-4ee0-9161-37cbaf44a666.jpg",
					"attributes": {
						"review_number": "4.77000",
						"not_contains_girls": "true",
						"term": "trouser",
						"reviewrating": "35",
						"decade": "054x",
						"century": "05xx",
						"new_arrival": "false",
						"dept": "0547",
						"brand": "cremieux",
						"pricerange": "average",
						"primary_category": "men",
						"can_ship_international": "true",
						"discount": null,
						"product_class": "343",
						"on_sale": "false"
					},
					"id": 295816421002,
					"title": "Cremieux Blue Label CMX 5-Pocket Tailored-Fit Sateen Stretch Pants",
					"refCode": "20375397"
				},
				{
					"prices": {
						"USD": {
							"unitPrice": 69.5,
							"salePrice": 69.5
						}
					},
					"url": "https://www.dillards.com/p/cremieux-madison-flat-front-twill-chino-pants/508522676",
					"img": "https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/cremieux-madison-flat-front-twill-chino-pants/00000000_zi_782fbf59-df51-42b4-9574-4f61ae9534d7.jpg",
					"attributes": {
						"review_number": "4.70000",
						"not_contains_girls": "true",
						"term": "trouser",
						"reviewrating": "90",
						"decade": "054x",
						"century": "05xx",
						"new_arrival": "false",
						"dept": "0547",
						"brand": "cremieux",
						"pricerange": "average",
						"primary_category": "men",
						"can_ship_international": "true",
						"discount": null,
						"product_class": "343|343",
						"on_sale": "false"
					},
					"id": 295816421052,
					"title": "Cremieux Blue Label Madison Classic Fit Comfort Stretch Flat-Front Twill Chino Pants",
					"refCode": "05585769"
				},
				{
					"prices": {
						"USD": {
							"unitPrice": 125,
							"salePrice": 125
						}
					},
					"url": "https://www.dillards.com/p/hart-schaffner-marx-tailored-single-pleat-chicago-dress-pants/505595789",
					"img": "https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/hart-schaffner-marx-tailored-single-pleat-chicago-dress-pants/04582746_zi_tan.jpg",
					"attributes": {
						"review_number": "4.39000",
						"not_contains_girls": "true",
						"term": "dress",
						"reviewrating": "28",
						"decade": "053x",
						"century": "05xx",
						"new_arrival": "false",
						"dept": "0535",
						"brand": "hart schaffner marx",
						"contains_dress": "true",
						"pricerange": "expensive",
						"primary_category": "men",
						"can_ship_international": "true",
						"discount": null,
						"product_class": "112|111",
						"on_sale": "false"
					},
					"id": 295816421102,
					"title": "Hart Schaffner Marx Tailored Regular Chicago Fit Single-Pleat Dress Pants",
					"refCode": "04582746"
				},
				{
					"prices": {
						"USD": {
							"unitPrice": 125,
							"salePrice": 125
						}
					},
					"url": "https://www.dillards.com/p/polo-ralph-lauren-classic-fit-stretch-mesh-zip-short-sleeve-polo-shirt/518205741",
					"img": "https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/polo-ralph-lauren-classic-fit-stretch-mesh-zip-short-sleeve-polo-shirt/00000001_zi_22d7cf3d-08a6-49f0-bb0a-a9876787055e.jpg",
					"attributes": {
						"review_number": "0.0",
						"not_contains_girls": "true",
						"term": "polo shirt",
						"reviewrating": "0",
						"decade": "054x",
						"century": "05xx",
						"new_arrival": "false",
						"dept": "0545",
						"brand": "polo ralph lauren",
						"pricerange": "expensive",
						"primary_category": "men",
						"can_ship_international": "true",
						"discount": null,
						"product_class": "620",
						"on_sale": "false"
					},
					"id": 295816421152,
					"title": "Polo Ralph Lauren Classic Fit Stretch Mesh Zip Short Sleeve Polo Shirt",
					"refCode": "20469132"
				},
				{
					"prices": {
						"USD": {
							"unitPrice": 125,
							"salePrice": 125
						}
					},
					"url": "https://www.dillards.com/p/hart-schaffner-marx-tailored-flat-front-chicago-dress-pants/505595908",
					"img": "https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/hart-schaffner-marx-tailored-flat-front-chicago-dress-pants/00000001_zi_grey04582755.jpg",
					"attributes": {
						"review_number": "4.58000",
						"not_contains_girls": "true",
						"term": "dress",
						"reviewrating": "26",
						"decade": "053x",
						"century": "05xx",
						"new_arrival": "false",
						"dept": "0535",
						"brand": "hart schaffner marx",
						"contains_dress": "true",
						"pricerange": "expensive",
						"primary_category": "men",
						"can_ship_international": "true",
						"discount": null,
						"product_class": "211",
						"on_sale": "false"
					},
					"id": 295816421202,
					"title": "Hart Schaffner Marx Classic Fit Flat-Front Dress Pants",
					"refCode": "04582755"
				}
			]
		}
	]
}



var setTopPersonalizationInfo = () => {
	
	topPersonalizationInfo = {
        favoriteSuperCat:'',
        favoriteSuperCatPoints: 0,
        favoriteBrand: '',
        favoriteBrandPoints: 0
    };
	var supersWeNeedToLookAt = ['410', '420', '425', '430', '435', '440', '445', '450', '470', '480'];
	
    for(var i = 0; i < supersWeNeedToLookAt.length; i++){
        var thisSuperId = supersWeNeedToLookAt[i];
        var thisPersonalizationData = localStorage.getItem('personalization' + thisSuperId);
        if(thisPersonalizationData){
            thisPersonalizationData = thisPersonalizationData.split('&amp;').join('&');
            var thisSuperPoints = 0;
            var thisSupersBrandPointData = thisPersonalizationData.split('|');
            for(var iBrand = 0; iBrand < thisSupersBrandPointData.length; iBrand++){
                var thisBrandPointData = thisSupersBrandPointData[iBrand].split(';'),
                    thisBrandName = thisBrandPointData[0].indexOf(':') > -1? thisBrandPointData[0].split(':')[1]:thisBrandPointData[0],
                    thisBrandPoints = thisBrandPointData[1]*1;
                thisSuperPoints += thisBrandPoints;
                if (thisBrandPoints > topPersonalizationInfo.favoriteBrandPoints) {
                    topPersonalizationInfo.favoriteBrand = thisBrandName;
                    topPersonalizationInfo.favoriteBrandPoints = thisBrandPoints;
                }
            }
            if(thisSuperPoints > topPersonalizationInfo.favoriteSuperCatPoints){
                topPersonalizationInfo.favoriteSuperCat = thisSuperId;
                topPersonalizationInfo.favoriteSuperCatPoints = thisSuperPoints;
            }
        }
    }
}

var zones = {}

var showRecs = (zone) => {
	if (zones[zone]) {
		return
	}
	zones[zone] = true
    try{
		if(window.location.host === 'localhost') setOptiRecs();
			if(window.optiSmartRecs){
			for(var i = 0; i < window.optiSmartRecs.length; i++){
				var recs = optiSmartRecs[i];
				if(recs.widget == zone){
					var responseData = (recs);
					var recRequestIds = [];
					var rec_attributes = [];
					for(var key in responseData.recs){
						var thisRec = responseData.recs[key];
						var attrs = [
								 thisRec.title
								,(thisRec.url.indexOf('dillards.com') > -1) ? thisRec.url.split('dillards.com')[1] : ''
								,(thisRec.img.indexOf('/') > -1) ? thisRec.img.split('/')[thisRec.img.split('/').length -1].split('.jpg').join('') : ''
								,(thisRec.reviewRating) ? thisRec.reviewRating : 0.0
								,'' //brand code
								,(thisRec.reviewNumber) ? thisRec.reviewNumber : ''
								, (thisRec.prices.USD.salePrice) ? ((thisRec.prices.USD.salePrice+"").split('.').length == 1 ? thisRec.prices.USD.salePrice+".00" : thisRec.prices.USD.salePrice+"") : ''
								, (thisRec.prices.USD.unitPrice) ? ((thisRec.prices.USD.unitPrice+"").split('.').length == 1 ? thisRec.prices.USD.unitPrice+".00" : thisRec.prices.USD.unitPrice+"") : ''
								,'true' //shipInternational
								,(thisRec.url.indexOf('/') > -1) ? thisRec.url.split('/')[thisRec.url.split('/').length -1] : ''
								,thisRec.dpt ? thisRec.dpt : ''
								,thisRec.mic ? thisRec.mic : ''
								,thisRec.attributes.brand ? (thisRec.attributes.brand.split(' ').map((s) => s.charAt(0).toUpperCase() + s.substring(1)).join(' ')) : ''
								,(thisRec.url.indexOf('dillards.com') > -1) ? thisRec.url.split('/')[4] : ''
								,(thisRec.id) ? thisRec.id : ''
							];
						if(attrs[0].indexOf('$entity') == -1 && attrs[1].length > 0 && attrs[2].length > 0 && attrs[9].length > 0 && attrs[12].length > 0 && attrs[13].length > 0){
							rec_attributes.push(attrs);
							recRequestIds.push(thisRec.id);
						}
					}
					responseData.recs.splice(i,1);
				}
			}
			productRecs[zone + '_zp']('',zone,'','','',rec_attributes,'','YOU MAY ALSO LIKE','','');
			if(recRequestIds){
				const listOfIds = "ids="+recRequestIds.join(",");
				const optiEnv = window.location.host === 'www.dillards.com' ? "dillardprod" : "dillardprep"
				Peerius?.sendAjax(optiEnv+"/rec/shown.pagex?"+listOfIds)
			}
		}
    }catch(er){
		if(debug){ console.log(er);}
    }
}


// var makeRecRequest = (zone, details, cartRecsFallbackZone) => {
//     var uniqueDetailArray = [];
//     var addedPids = '';
//     if(details && details.promotedDetails){
//     	for(var thisDetail of details.promotedDetails){
//     		if(thisDetail && thisDetail.pid && addedPids.indexOf(thisDetail.pid) === -1 && uniqueDetailArray.length < 5){
//     			uniqueDetailArray.push(thisDetail);
//                 addedPids += thisDetail.pid + '|';
//     		}
//     	}
//     }
    
//     var totalProducts = uniqueDetailArray.length;
//     for(let thisDetail of uniqueDetailArray){
    	
//     	var target = {};
//     	target.cartIds = thisDetail.pid;
//     	target.decade = (thisDetail.dept) ? thisDetail.dept.slice(0,thisDetail.dept.length -1) + 'X' : '';
//     	target.century = (thisDetail.dept) ? thisDetail.dept.slice(0,thisDetail.dept.length -2) + 'XX' : '';
//     	target.dept = (thisDetail.dept) ? thisDetail.dept : '';
//     	target.mic = (thisDetail.mic) ? thisDetail.mic : '';
//     	target.brand = (thisDetail.brand) ? thisDetail.brand : '';
//     	target.group = (thisDetail.group) ? thisDetail.group : '';
//     	target.name = (thisDetail.name) ? thisDetail.name : '';
//     	target.newArrival = (thisDetail.newArrival) ? thisDetail.newArrival : '';
//     	target.productClass = (thisDetail.productClass) ? thisDetail.productClass : '';
//     	target['profile.favoriteBrand'] = (topPersonalizationInfo && topPersonalizationInfo.favoriteBrand) ? topPersonalizationInfo.favoriteBrand : '';
//     	target['profile.favoriteCategoryId'] = (topPersonalizationInfo && topPersonalizationInfo.favoriteSuperCat) ? topPersonalizationInfo.favoriteSuperCat : '';

//     	try{
//     		if(thisDetail.cat && Math.sign(thisDetail.cat) === 1){
//     			target['entity.category'] = thisDetail.cat;
//     			target['entity.categoryId'] = thisDetail.cat;
//     		}
//     	}catch(e){
//     		if(debug){ console.log(e); }
// 		}
    	  
//     	var data = {};
//     	data.__adobe = {};
//     	data.__adobe.target = target;
    	
// 		alloy_dillards("sendEvent", {
// 			xdm: {
// 				eventType: 'pushTracking.customAction',
// 				productListItems: [{SKU: thisDetail.pid}]
// 			},
// 			data: data,
// 			decisionScopes: [
// 				cartRecsFallbackZone
// 			]
// 		}).then(function (resp) {
// 			setOptiRecs();
// 			//var thisProp = (resp && resp.propositions && resp.propositions.length > 0) ? resp.propositions[0] : {};
// 			//var responseData = (thisProp && thisProp.items && thisProp.items[0] && thisProp.items[0].data && thisProp.items[0].data.content) ? JSON.parse(thisProp.items[0].data.content) : {};
// 			if (window.optiSmartRecs) {
// 				var rec_attributes = [];
// 				for (var i = 0; i < window.optiSmartRecs.length; i++) {
// 					var thisContent = window.optiSmartRecs[0];
// 					if (thisContent.widget === "basketWidget") {
// 						var responseData = (thisContent);

// 						if (debug) { console.log('pid: ' + thisDetail.pid + ' returned recs:', responseData.recs); }
// 						//, (thisRec.prices.USD.salePrice) ? ((thisRec.prices.USD.salePrice+"").split('.').length == 1 ? thisRec.prices.USD.salePrice+".00" : thisRec.prices.USD.salePrice) : ''
// 						//, (thisRec.prices.USD.unitPrice) ? ((thisRec.prices.USD.unitPrice+"").split('.').length == 1 ? thisRec.prices.USD.unitPrice+".00" : thisRec.prices.USD.unitPrice) : ''
// 						for (var key in responseData.recs) {
// 							var thisRec = responseData.recs[key];
// 							var attrs = [
// 								thisRec.title
// 								, (thisRec.url.indexOf('dillards.com') > -1) ? thisRec.url.split('dillards.com')[1] : ''
// 								, (thisRec.img.indexOf('/') > -1) ? thisRec.img.split('/')[thisRec.img.split('/').length - 1].split('.jpg').join('') : ''
// 								, (thisRec.reviewRating) ? thisRec.reviewRating : 0.0
// 								, '' //brand code
// 								, (thisRec.reviewNumber) ? thisRec.reviewNumber : ''
// 								, (thisRec.prices.USD.salePrice) ? ((thisRec.prices.USD.salePrice+"").split('.').length == 1 ? thisRec.prices.USD.salePrice+".00" : thisRec.prices.USD.salePrice+"") : ''
// 								, (thisRec.prices.USD.unitPrice) ? ((thisRec.prices.USD.unitPrice+"").split('.').length == 1 ? thisRec.prices.USD.unitPrice+".00" : thisRec.prices.USD.unitPrice+"") : ''
// 								, 'true' //shipInternational
// 								, (thisRec.url.indexOf('/') > -1) ? thisRec.url.split('/')[thisRec.url.split('/').length - 1] : ''
// 								, thisRec.dpt ? thisRec.dpt : ''
// 								, thisRec.mic ? thisRec.mic : ''
// 								, thisRec.attributes.brand ? (thisRec.attributes.brand.split(' ').map((s) => s.charAt(0).toUpperCase() + s.substring(1)).join(' ')) : ''
// 								, (thisRec.url.indexOf('dillards.com') > -1) ? thisRec.url.split('/')[4] : ''
// 							];
// 							if (attrs[0].indexOf('$entity') == -1 && attrs[1].length > 0 && attrs[2].length > 0 && attrs[9].length > 0 && attrs[12].length > 0 && attrs[13].length > 0) {
// 								rec_attributes.push(attrs);
// 							}
// 						}
// 					}
// 				}
// 				if (rec_attributes.length > 0) {
// 					recsArrayInit.push(rec_attributes);
// 				} else {
// 					totalProducts--;
// 				}

// 				if (recsArrayInit.length == totalProducts) {
// 					if (recsArrayInit.length > 0) {
// 						var addedPartnums = [];

// 						for (var i = 0; i < maxRecSize; i++) {
// 							for (var thisArray of recsArrayInit) {
// 								if (thisArray[i] && addedPartnums.indexOf(thisArray[i][9]) == -1) {
// 									recsArrayFinal.push(thisArray[i])
// 									addedPartnums.push(thisArray[i][9]);

// 									if (recsArrayFinal.length == maxRecSize) {
// 										i = maxRecSize;
// 									}
// 								}
// 							}
// 						}

// 						if (debug) { console.log('Final Result: ', recsArrayFinal); }

// 						productRecs[zone + '_zp']('', zone, '', '', '', recsArrayFinal, '', 'YOU MAY ALSO LIKE', '', '');
// 					}
// 				}
// 			}
// 		});
// 	}
// }




// var setInteractionData = (zone) => {
//     if(window.recContent){
//         for(var i = 0; i < window.recContent.length; i++){
//             var thisContent = window.recContent[i];
            
//             if(thisContent.scope === zone){
//                 if(thisContent &&
//                    thisContent.rawData &&
//                    thisContent.rawData.id &&
//                    thisContent.rawData.scope &&
//                    thisContent.rawData.scopeDetails){
//                         recInteractionData.recId = thisContent.rawData.id;
//                         recInteractionData.recZone = thisContent.rawData.scope;
//                         recInteractionData.recScopeDetails = thisContent.rawData.scopeDetails;
//                 }
//                 try { $(document).trigger('makeRecRequest'); } catch (e) {}
//             }
//         }
//     }
// }



